import update from 'react-addons-update';
import {
  ATTACHMENTS_FETCH_START,
  ATTACHMENTS_FETCH_API_FULFILLED,
  ATTACHMENTS_FETCH_API_REJECTED,
  ATTACHMENT_CREATE_API_FULFILLED,
  ATTACHMENT_DELETE_API_FULFILLED,
  DELETE_ATTACHMENT,
} from '../actions';

const initialState = {
  list: [],
  issueId: '',
  isLoading: false,
};

export default (state = initialState, action) => {
  let list = [];
  // eslint-disable-next-line default-case
  switch (action.type) {
    case ATTACHMENTS_FETCH_START:
      if (state.issueId !== action.payload) {
        return update(state, { issueId: { $set: action.payload }, list: { $set: []}, isLoading: { $set: true }});
      }
      return update(state, { isLoading: { $set: true }});
    case ATTACHMENTS_FETCH_API_FULFILLED: {
      if (action.payload.length) {
        // Update all new attachments we just got from BE with `fileId` field from the current attachment list (if exists).
        // We need to continue using `fileId` key for attachment animations.
        const prevAttachmentIdToFileId = state.list.reduce((map, attachment) => {
          if (attachment.fileId) {
            map[attachment.id] = attachment.fileId;
          }
          return map;
        }, {});
        const newAttachmentList = action.payload.map(a => Object.assign({}, a, { fileId: prevAttachmentIdToFileId[a.id] }));
        return update(state, {
          list: { $set: newAttachmentList },
          issueId: { $set: action.meta.id },
          isLoading: { $set: false },
        });
      } else {
        return update(state, {
          isLoading: { $set: false },
        });
      }
    }
    case ATTACHMENTS_FETCH_API_REJECTED:
      return update(state, { isLoading: { $set: false }});
    case ATTACHMENT_CREATE_API_FULFILLED: {
      if (state.issueId === action.payload.issueId) {
        list = [Object.assign({}, action.payload, { fileId: action.meta.fileId })].concat(state.list);
        return update(state, { $merge: { list }});
      }
      break;
    }
    case DELETE_ATTACHMENT:
      list = state.list.map(a => a.id === action.payload.attachmentId ? { ...a, isDeleting: true } : a);
      return update(state, { $merge: { list }});
    case ATTACHMENT_DELETE_API_FULFILLED:
      list = state.list.filter(file => file.id !== action.meta.attachmentId);
      return update(state, { $merge: { list }});
  }
  return state;
};
